<template src="./template.html"></template>
<script>

export default {
  name: 'Footer',
  data() {
    return{
      globalSupplier: this.$supplier.links,
    }
  },
};

</script>



// WEBPACK FOOTER //
// src/components/modules/04_footer/index.vue